// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + "2a4bfb0aca024b97ebd4" + ".newapp.chunk.js";
};